var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{on:{"click":function($event){return _vm.$emit('MostrarCarousel')}}},[(_vm.loadingImg)?_c('LoaderIframe'):_vm._e(),_c('img',{attrs:{"src":_vm.img,"alt":`${_vm.show.nombre} ${_vm.show.ano} ${_vm.show.ubicacion}`},on:{"load":function($event){return _vm.LoadedImg()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }